import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { CalendarClock, Plus, LogIn, LogOut, Clock } from 'lucide-react'
import { schedulingService, AttendanceSummary } from '@/services/schedulingService'

export default function SchedulingPage() {
    const [form, setForm] = useState({ name: '', startsAt: '', endsAt: '' })
    const [attendance, setAttendance] = useState<AttendanceSummary | null>(null)

    const loadAttendance = () => schedulingService.myAttendance().then(setAttendance).catch(() => {})
    useEffect(() => { loadAttendance() }, [])

    const createShift = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!form.name || !form.startsAt || !form.endsAt) return toast.error('Completa nombre y horario')
        try {
            await schedulingService.createShift({ name: form.name, startsAt: form.startsAt, endsAt: form.endsAt })
            toast.success('Turno creado'); setForm({ name: '', startsAt: '', endsAt: '' })
        } catch { toast.error('Error al crear turno') }
    }

    const clockIn = async () => {
        try { await schedulingService.clockIn(); toast.success('Entrada registrada'); loadAttendance() }
        catch { toast.error('No se pudo marcar entrada') }
    }
    const clockOut = async () => {
        try { await schedulingService.clockOut(); toast.success('Salida registrada'); loadAttendance() }
        catch (e: any) { toast.error(e?.response?.data?.error || 'No se pudo marcar salida') }
    }

    const inp = 'w-full bg-gray-900 border border-gray-700 rounded px-3 py-2 text-sm'
    const card = 'bg-gray-800/40 border border-gray-700 rounded-lg p-4'

    return (
        <div className="p-6 text-gray-100">
            <div className="flex items-center gap-3 mb-6"><CalendarClock className="text-indigo-400" /><h1 className="text-2xl font-bold">Turnos</h1></div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <form onSubmit={createShift} className={card + ' space-y-3'}>
                    <h2 className="font-semibold flex items-center gap-2"><Plus size={16} /> Nuevo turno</h2>
                    <input className={inp} placeholder="Nombre (p. ej. Turno Noche)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    <label className="text-xs text-gray-400">Inicio</label>
                    <input type="datetime-local" className={inp} value={form.startsAt} onChange={(e) => setForm({ ...form, startsAt: e.target.value })} />
                    <label className="text-xs text-gray-400">Fin</label>
                    <input type="datetime-local" className={inp} value={form.endsAt} onChange={(e) => setForm({ ...form, endsAt: e.target.value })} />
                    <button className="w-full bg-indigo-600 hover:bg-indigo-500 rounded px-3 py-2 text-sm font-medium">Crear turno</button>
                </form>

                <div className={card + ' space-y-4'}>
                    <h2 className="font-semibold flex items-center gap-2"><Clock size={16} /> Mi asistencia</h2>
                    <div className="flex gap-2">
                        <button onClick={clockIn} className="flex-1 bg-emerald-600 hover:bg-emerald-500 rounded px-3 py-2 text-sm font-medium flex items-center justify-center gap-2"><LogIn size={16} /> Entrada</button>
                        <button onClick={clockOut} className="flex-1 bg-amber-600 hover:bg-amber-500 rounded px-3 py-2 text-sm font-medium flex items-center justify-center gap-2"><LogOut size={16} /> Salida</button>
                    </div>
                    {attendance && (
                        <div className="bg-gray-900/50 rounded p-3 text-sm">
                            <div>Marcas: <span className="font-semibold">{attendance.entries}</span></div>
                            <div>Tiempo trabajado: <span className="font-semibold">{Math.floor(attendance.totalMinutes / 60)}h {attendance.totalMinutes % 60}m</span></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
